var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85345 9.85345C9.65805 10.0489 9.3419 10.0489 9.14628 9.85345L5.00047 5.7067L0.853717 9.85345C0.658316 10.0489 0.34217 10.0489 0.14655 9.85345C-0.0488501 9.65805 -0.0488501 9.3419 0.14655 9.14628L4.29424 5.00047L0.147175 0.853717C-0.0482251 0.658317 -0.0482251 0.34217 0.147175 0.14655C0.342576 -0.0488501 0.658723 -0.0488501 0.854342 0.14655L5.00047 4.29424L9.14722 0.147488C9.34262 -0.0479127 9.65877 -0.0479127 9.85439 0.147488C10.0498 0.342888 10.0498 0.659035 9.85439 0.854655L5.7067 5.00047L9.85345 9.14722C10.0503 9.34097 10.0503 9.65971 9.85345 9.85345Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.c752573b301970436f425ef369fdf650.svg";
export { ForwardRef as ReactComponent };